import { createReducer } from "redux-act";
import createAction from "../utils/createMetaAction";
export const updateAvailability = createAction("updateAvailability");
export default createReducer(
  {
    [updateAvailability]: (state, payload) => {
      return payload;
    }
  },
  true
);
